import {InjectionToken} from '@angular/core';

export const APP_PROD_MODE = new InjectionToken<boolean>('APP_PROD_MODE');
